import { Component, effect, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { RemoteStore } from '@navstation-portal/iframe/data-access/remote';
import { PrimeNG } from 'primeng/config';
import { Events, injectDispatch } from '@ngrx/signals/events';
import {
  authEvents,
  AuthStore,
} from '@navstation-portal/shared/data-access/auth';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Toast } from 'primeng/toast';
import { Toaster } from '@navstation-portal/shared/feature/toaster';
import { ThemeService } from '@navstation-portal/shared/data-access/theme';
import {
  AppStore,
  appEvents,
} from '@navstation-portal/reporting/data-access/app';
import { LoadingOverlayComponent } from '@navstation-portal/reporting/ui/shared';
import { AppBarComponent } from './app-bar/app-bar.component';

@Component({
  selector: 're-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  imports: [RouterOutlet, AppBarComponent, Toast, LoadingOverlayComponent],
})
export class AppComponent implements OnInit {
  title = 'nav-reporting-app';
  router = inject(Router);
  appStore = inject(AppStore);
  authStore = inject(AuthStore);
  primeng = inject(PrimeNG);
  store = inject(RemoteStore);
  readonly toaster = inject(Toaster);
  events = inject(Events);
  appDispatch = injectDispatch(appEvents);
  themeService = inject(ThemeService);

  headless = this.store.isHeadless;

  constructor() {
    this.events
      .on(authEvents.loginSuccess)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        const vesselId = this.authStore.defaultVesselId();
        if (!vesselId) return;

        this.appDispatch.setSelectedVesselId(vesselId);
        this.appDispatch.setDefaultVesselId(vesselId);
      });

    this.events
      .on(authEvents.logoutSuccess)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.appDispatch.reset();
        this.router.navigate(['/login']);
      });

    effect(() => {
      const theme = this.store.settings().theme;
      if (theme) this.themeService.setTheme(theme);
    });
  }

  ngOnInit() {
    this.primeng.ripple.set(true);
  }
}
